import React from "react";
import ScrollToTopOnMount from "../../scrollComponents/ScrollToTopOnRoute";
import { FaFacebook, FaWhatsapp, FaPhone, FaEnvelope } from "react-icons/fa";

const Contact = () => {
  return (
    <div className="px-6 py-12 max-w-3xl mx-auto">
      <ScrollToTopOnMount />

      <h2 className="text-3xl md:text-4xl font-[Lora] font-bold text-[#2c7b2f] text-center mb-10">
        Get in Touch
      </h2>

      <div className="bg-white shadow-lg rounded-xl p-8 space-y-6 text-center">
        <p className="text-gray-700 text-lg">
          We'd love to hear from you! You can reach us through any of the options below:
        </p>

        <div className="space-y-8">
          {/* Business Contact */}
          <div>
            <h3 className="font-semibold text-[#2c7b2f] text-2xl mb-4">
              S&J Solutions
            </h3>

            {/* WhatsApp */}
            <a
              href="https://wa.me/27718825578"
              className="flex items-center justify-center gap-3 text-[#2c7b2f] hover:underline text-lg mb-2"
            >
              <FaWhatsapp /> WhatsApp Us
            </a>

            {/* Call */}
            <a
              href="tel:+27718825578"
              className="flex items-center justify-center gap-3 text-[#2c7b2f] hover:underline text-lg mb-2"
            >
              <FaPhone /> 071 882 5578
            </a>

            {/* Email */}
            <a
              href="mailto:sandjsolutions1@gmail.com"
              className="flex items-center justify-center gap-3 text-[#2c7b2f] hover:underline text-lg mb-2"
            >
              <FaEnvelope /> sandjsolutions1@gmail.com
            </a>

            {/* Facebook */}
            <a
              href="https://www.facebook.com/profile.php?id=61584568802723"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center gap-3 text-[#2c7b2f] hover:underline text-lg"
            >
              <FaFacebook /> Visit our Facebook Page
            </a>
          </div>
        </div>

        <div className="mt-8 border-t pt-6 text-gray-600 text-sm">
          <p>We typically respond as soon as possible.</p>
        </div>
      </div>
    </div>
  );
};

export default Contact;
